<div class="carousel-container" cdkTrapFocus>
  <div class="overlay"></div>

  <div class="img-container">
    <img
      class="img"
      [src]="baseUrl + '/' + images[activeIndex].largeUrl"
      [attr.alt]="images[activeIndex].alt"
    />
  </div>

  <div class="thumbnails">
    <button
      class="thumbnail"
      [class.active]="activeIndex === idx"
      *ngFor="let image of images; let idx = index"
      (click)="activeIndex = idx"
    >
      <img [src]="baseUrl + '/' + image.smallUrl" [attr.alt]="image.alt" />
    </button>
  </div>

  <button
    type="button"
    mat-icon-button
    class="close-btn"
    (click)="closed.emit()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
